<template>
  <div
    id="apply-prompt"
    :class="{ 'editing-form': editAction }"
    class="form-container position-relative"
  >
    <div v-show="logging" class="loading-mask">
      <i class="fas fa-circle-notch fa-spin" />
    </div>
    <div v-show="!editAction" :class="{'no-bg': isLoggedIn}" autocomplete="off" class="apply-prompt-wrap">
      <h2 v-show="!isLoggedIn">
        {{ cpLang("apply.form") }}
      </h2>
      <h6>{{ cpLang("apply.for") }}</h6>
      <h3>{{ job.jobtitletext }}</h3>
      <h4>{{ job.displayname }}</h4>
      <!-- for login form -->
      <div v-if="!isLoggedIn && !requirePassword" class="row bypass">
        <div class="col-sm-6">
          <div
            :class="{ 'has-danger': inputError === 'email' }"
            class="col-12 col-xs-12"
          >
            <h5>
              {{ cpLang("login.login") }}
              <label v-if="formError" class="text-danger">{{
                formError
              }}</label>
            </h5>
            <input
              v-model="email"
              :placeholder="cpLang('apply.email')"
              @blur="validateEmail"
              type="text"
              class="form-control"
              required
            >
          </div>
          <div
            :class="{ 'has-danger': inputError === 'password' }"
            class="col-12 col-xs-12 position-relative"
          >
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              :placeholder="cpLang('placeholder.password')"
              class="form-control"
              required
            >
            <i
              @click="showPassword = !showPassword"
              :class="{
                'fa-low-vision': !showPassword,
                'fa-eye': showPassword,
              }"
              class="fas"
            />
          </div>
          <div class="col-12">
            <span>
              <a
                id="forgot-link"
                @click="forgotPassword"
                href="javascript:void(0)"
                >{{ cpLang("login.forgot") }}</a>
            </span>
          </div>
        </div>
        <div class="col-sm-6 login-authbox">
          <AuthBox />
        </div>
        <div class="text-center m-auto">
          <br>
          <button @click="doLogin" class="btn btn-primary">
            {{ cpLang("login.login") }}
          </button>
          <p class="to-reg">
            {{ cpLang("login.notyet")
            }}<b @click="goToRegister" class="text-primary">{{
              cpLang("login.signhere")
            }}</b>
          </p>
        </div>
      </div>
      <!-- for register form-->
      <div v-if="!isLoggedIn && requirePassword" class="reg-wrap">
        <div class="row bypass">
          <div class="col-sm-7">
            <div class="col-12 col-xs-12">
              <h5>
                {{ cpLang("login.apply_signup") }}
                <label v-if="formError" class="text-danger">{{
                  formError
                }}</label>
              </h5>
              <div id="email">
                <input
                  id="email_box"
                  v-model="email"
                  :placeholder="cpLang('apply.email')"
                  @blur="validateEmail"
                  type="text"
                  class="form-control"
                  required
                >
              </div>
              <div />
            </div>
            <div
              :class="{ 'has-danger': inputError === 'password' }"
              class="col-sm-12 col-xs-12 position-relative"
            >
              <input
                id="new-password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="cpLang('apply.create_password')"
                @focus="showPasswordTips = true"
                @blur="(showPasswordTips = false), validateForm"
                class="form-control"
                required
              >
              <i
                @click="showPassword = !showPassword"
                :class="{
                  'fa-low-vision': !showPassword,
                  'fa-eye': showPassword,
                }"
                class="fas"
              />
              <div :class="showPasswordTips ? 'show' : ''" class="tooltip">
                <i class="fas fa-sort-up" />
                {{ cpLang("login.password_tips") }}
              </div>
            </div>
            <div
              :class="{ 'has-danger': inputError === 'confirmPassword' }"
              class="col-sm-12 col-xs-12"
            >
              <input
                id="confirm_box"
                v-model="confirmPassword"
                :placeholder="cpLang('login.forget_cofirm')"
                @blur="validateForm"
                type="password"
                class="form-control"
                required
              >
            </div>
            <div class="">
              <div class="col-4">
                <div>
                  <AutoComplete
                    :auto-complete-data="genderList"
                    :input-props="{id:'gender-reg-txt', placeholder:cpLang('global.select'),value: genderList[0].desc}"
                    @selected="selectGender"
                    read-only
                    no-icon
                    class="white"
                  />
                </div>
              </div>
              <div class="col-4 pl-0">
                <div :class="{ 'has-danger': inputError === 'firstname' }">
                  <input
                    id="firstname-txt"
                    v-model="firstname"
                    :placeholder="cpLang('apply.firstname')"
                    type="text"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="col-4 pl-0">
                <div :class="{ 'has-danger': inputError === 'lastname' }">
                  <input
                    id="lastname-txt"
                    v-model="lastname"
                    :placeholder="cpLang('apply.lastname')"
                    type="text"
                    class="form-control"
                  >
                </div>
              </div>
            </div>
            <div
              :class="{ 'has-danger': inputError === 'verify' }"
              class="col-sm-12 col-xs-12"
            >
              <i :class="{ disable: enableVerCode }" class="fas fa-keyboard" />
              <input
                id="reg_code"
                :disabled="!enableVerCode"
                v-model="code"
                @blur="validateForm"
                :placeholder="cpLang('placeholder.verification')"
                class="form-control"
                minlength="4"
                maxlength="4"
                type="text"
                required
              >

              <input
                v-if="sent && countDown"
                :value="countDown + ' s'"
                class="btn btn-primary btn-send btn-xs disabled"
                disabled
                type="button"
              >
              <input
                v-if="sent && !countDown"
                @click="sendVerificationCode"
                :value="cpLang('login.resend')"
                class="btn btn-primary btn-send btn-xs"
                type="button"
              >
              <input
                v-if="!sent"
                @click="sendVerificationCode"
                :value="cpLang('login.forgot_send')"
                class="btn btn-primary btn-send btn-xs"
                type="button"
              >
              <div />
              <div class="text-success">
                <small>{{ sentVerifyCode }}</small>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 verify-msg">
              {{ cpLang("login.apply_verify") }}
            </div>
          </div>
          <div class="col-sm-5">
            <AuthBox />
          </div>
          <div class="col-12 text-center my-4 position-relative up-index">
            <button @click="sent && agree ? register() : (showTooltip = true)" :disabled="!sent" class="btn btn-primary position-relative">
             {{ cpLang('profile.next') }}
            </button>
            <div v-show="showTooltip" class="form-check cs-tooltip">
              <input
                v-model="agree"
                type="checkbox"
                class="form-check-input my-0"
              >
              <span v-html="cpLang('login.register_agree')" class="form-check-label" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopUp
      :clicked="showDeleteResume"
      :callback="closeDeleteResume"
      class="cv-prompt"
      close
      disable-click-outside
    >
      <h5>{{ cpLang("apply.max_cv") }}</h5>
      <table width="100%">
        <tbody>
          <tr v-for="cv in resumes" :key="'cv-' + cv.id">
            <td>{{ cv.filename }}.{{ cv.filetype }}</td>
            <td width="100">
              {{
                cv.createddate !== undefined
                  ? toDate(cv.createddate.date)
                  : cpLang("global.just_now")
              }}
            </td>
            <td width="30">
              <i @click="deleteResume(cv)" class="fa fa-times" />
            </td>
          </tr>
        </tbody>
      </table>
    </PopUp>
    <PopUp
      :clicked="forgotPasswordSent"
      :callback="closeForgotPassword"
      class="headless text-center small"
      close
      disable-click-outside
    >
      <img src="asset/image/icon/icon-email.svg">
      <h5>{{ cpLang("login.check_mail") }}</h5>
      <p>
        {{ cpLang("login.email_sent") }}
      </p>
    </PopUp>
    <div v-if="this.$auth.loggedIn">
      <div class="preview-profile-section">
        <PreviewProfile v-if="!editAction" @edit="editProfile" @submit="submitJob" />
        <EditPreviewProfile
          v-else
          :is-edit="editAction"
          @change="editAction = !editAction"
        />
        <!-- <div v-if="!editAction" class="text-center mt-3">
          <button @click="editProfile" class="btn btn-primary">
            {{ cpLang("profile.edit") }}
          </button>
          <button @click="submitForm" class="btn btn-primary">
            {{ cpLang("global.submit") }}
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// VueDropboxPicker cannot display in second time
// import VueDropboxPicker from 'vue-dropbox-picker'
// import CvUpload from '@/components/profile/CvUpload'
import AutoComplete from '@/components/global/AutoComplete'
import PopUp from '@/components/global/Popup'
import PreviewProfile from '@/components/profile/PreviewProfile'
import EditPreviewProfile from '@/components/profile/EditPreviewProfile'
import AuthBox from '@/components/user/AuthBox'
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  components: {
    PopUp,
    PreviewProfile,
    EditPreviewProfile,
    AuthBox,
    AutoComplete
    // CvUpload
  },
  props: {
    job: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      showPassword: false,
      googleApiKey: 'AIzaSyBAe9JAsqiYS6SwjDMKa_wehzXp-vsuucI',
      googleClientId:
        '383374912586-39itil7lbs3bco5j8hom9ecbgu4lgj52.apps.googleusercontent.com',
      email: '',
      firstname: '',
      lastname: '',
      code: '',
      agree: false,
      permit: false,
      countDown: 15,
      timer: false,
      subscribe: false,
      valid: false,
      error: false,
      showApply: false,
      isMember: false,
      loginAfterRegister: false,
      cvViewed: false,
      logging: true,
      forgotPasswordSent: false,
      parentNode: false,
      requirePassword: false,
      password: '',
      resumes: [],
      acceptedMimeTypes: [
        'application/msword',
        'application/vnd.ms-word',
        'application/vnd',
        'application/pdf',
        'application/rtf',
        'application/x-pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'text/rtf',
        'text/html',
        'application/msword; charset=binary'
      ],
      filename: '',
      uploadFrom: '',
      uploadFileName: '',
      uploadFileLink: '',
      confirmPassword: '',
      ipCountry: '',
      showDeleteResume: false,
      uploadEvent: false,
      formError: false,
      inputError: false,
      sent: false,
      cvError: false,
      afterSubmit: false,
      cvPreviewUrl: false,
      submitting: false,
      pendingFile: false,
      newsLetterStatus: false,
      jobAlertStatus: false,
      thirdPartyStatus: false,
      resumeid: 0,
      enableVerCode: false,
      showPasswordTips: false,
      sentVerifyCode: '',
      editAction: false,
      genderList: [
        { id: 1, desc: this.cpLang('Prof.') },
        { id: 2, desc: this.cpLang('Dr.') },
        { id: 3, desc: this.cpLang('Mr.') },
        { id: 4, desc: this.cpLang('Ms.') },
        { id: 5, desc: this.cpLang('Mrs.') },
        { id: 6, desc: this.cpLang('Miss') }
      ],
      gender: this.cpLang('Prof.'),
      showTooltip: false
    }
  },
  computed: {
    isProduction: function () {
      return commonHelper.isProduction()
    },
    isLoggedIn: function () {
      return this.$auth.user
    }
  },
  watch: {
    resumeid: function () {
      this.validateForm()
      const vm = this
      vm.resumes.forEach(function (item) {
        if (item.id === vm.resumeid) {
          vm.cvPreviewUrl = item.preview
        }
      })
    },
    email: 'validateForm',
    firstname: 'validateForm',
    lastname: 'validateForm',
    password: 'validateForm',
    filename: function () {
      const vm = this
      let selectedIndex = 0
      const d = new Date()
      const tempFile = {
        id: 0,
        key: d.getTime(),
        filename: vm.filename,
        filetype: '',
        preview: false
      }
      vm.resumes.forEach(function (item, index) {
        if (item.id === 0) {
          vm.resumes.pop()
        }
      })
      vm.resumes.push(tempFile)
      selectedIndex = vm.resumes.length - 1
      vm.cvPreviewUrl = false
      vm.$nextTick(() => {
        vm.selectResume(selectedIndex)
      })
      this.validateForm()
    }
  },
  beforeMount() {
    this.initial()
  },
  mounted() {
    // this.initial()
    this.logging = false
    if (this.isProduction) {
      this.initLocation()
    }
  },
  methods: {
    sendVerificationCode: async function () {
      const vm = this
      this.afterSubmit = true
      if (!vm.validateForm(true)) {
        return false
      }
      vm.logging = true
      vm.countDown = 15
      vm.timer = setInterval(function () {
        vm.countDown -= 1
        if (vm.countDown <= 0) {
          vm.countDown = 0
          clearInterval(vm.timer)
        }
      }, 1000)
      const params = { email: this.email, firstname: this.firstname }
      try {
        await this.$axios.get('candidate/verify', { params: params })
        vm.sent = true
        vm.enableVerCode = true
        vm.showApply = true
        vm.logging = false
        // commonHelper.toast(vm.cpLang(vm.cpLang('login.verification_sent'), 'primary')
        vm.sentVerifyCode = vm.cpLang('login.verification_sent')
      } catch (err) {
        vm.logging = false
        vm.error = err
      }
    },
    initLocation: async function () {
      const vm = this
      await this.$axios
        .get(
          'https://apigw.scmp.com/geo-location/v1?apikey=nN43c0i8l7BGOy2ca8bugIAzr0310kux'
        )
        .then(function (response) {
          const data = JSON.parse(JSON.stringify(response.data))
          if (data['CF-IPCountry'] !== undefined) {
            vm.ipCountry = data['CF-IPCountry']
          }
        })
        .catch(() => {
          console.warn('Cannot get the client location')
        })
    },
    editProfile: function () {
      this.editAction = true
    },
    uploadCv: function (filedata, filename) {
      this.pendingFile = filedata
      this.filename = filename
    },
    initial: function () {
      if (this.$auth.loggedIn) {
        this.requirePassword = false
        this.email = this.$auth.user.email
        this.firstname = this.$auth.user.firstname
        this.lastname = this.$auth.user.lastname
        this.checkApplyStatus()
      }
      // for mixpanel tracking
      const mpJobObject = commonHelper.getMixpanelProperty(this.job)
      mpJobObject.type = 'view'
      const eventName = this.$auth.user
        ? 'App-form (mem)'
        : 'App-form (non-mem)'
      mpJobObject.event = eventName
      this.$gtm.pushEvent({
        event: 'jobApplyForm',
        queryString: JSON.stringify(mpJobObject)
      })
    },
    checkApplyStatus: function () {
      const vm = this
      try {
        this.$axios
          .get('applications?positionid=' + vm.$route.params.id)
          .then(function (response) {
            const data = JSON.parse(JSON.stringify(response.data))
            if (data.total > 0) {
              vm.showApplied()
            } else {
              vm.getResume()
              vm.isMember = true
              vm.showApply = true
              vm.logging = false
            }
          })
      } catch (err) {
        // err.response
      }
    },
    toDate: function (date) {
      date = date.replace('.000000', '')
      const datetime = new Date(date.replace(/-/g, '/'))
      const timestamp = datetime.getTime()
      return commonHelper.toExiprationDate(timestamp)
    },
    closeDeleteResume: function () {
      this.showDeleteResume = false
    },
    closeForgotPassword: function () {
      this.forgotPasswordSent = false
    },
    resumeUpload: function () {
      const event = this.uploadEvent
      event.target.click()
    },
    goToRegister: function () {
      this.isMember = false
      this.requirePassword = true
    },
    deleteResume: function (cv) {
      this.resumes.splice(this.resumes.indexOf(cv), 1)
      this.showDeleteResume = false
      const vm = this
      // delete the non-uploaded CV
      if (!cv.id) {
        if (document.querySelector('.cv-upload .selected')) {
          document
            .querySelector('.cv-upload .selected')
            .classList.remove('selected')
        }
        vm.validateForm()
      }
      try {
        this.$axios.delete('member/resume/' + cv.id).then(function (response) {
          const data = JSON.parse(JSON.stringify(response.data))
          const status = data.status
          if (status === 'success') {
            vm.resumeUpload()
          }
        })
      } catch (err) {
        // err.response
      }
    },
    selectResume: function (index) {
      const defaultCv = document.querySelectorAll('.cv-option li input')[index]
      if (defaultCv !== undefined) {
        defaultCv.checked = true
        this.cvPreviewUrl = this.resumes[index].preview
        this.resumeid = this.resumes[index].id
      }
    },
    getResume: function (selectRecent) {
      const vm = this
      if (selectRecent === undefined) {
        selectRecent = false
      }
      let uri = 'member/resume'
      if (selectRecent) {
        uri += '?order=date'
      }
      try {
        this.$axios.get(uri).then(function (response) {
          const data = JSON.parse(JSON.stringify(response.data))
          vm.resumes = data.resumes
          // set default
          vm.$nextTick(() => {
            if (selectRecent) {
              vm.selectResume(0)
              return
            }
            vm.resumes.forEach(function (item, index) {
              if (item.isdefault === '1') {
                vm.selectResume(index)
                return false
              }
            })
          })
        })
      } catch (err) {
        // err.response
      }
    },
    resumeUploaded: function () {
      this.getResume(true)
    },
    submitJob: function() {
      const vm = this
      const formData = new FormData()
      formData.append('positionid', this.$route.params.id)
      formData.append('tag', 'jobdetail_normal')
      console.log(this.$route.params.id)
      this.logging = true
      this.$axios.post('applications', formData, { headers: { 'Content-Type': 'application/form-data' } })
        .then(function(response) {
          const result = response.data
          if (result.status === 'success') {
            vm.showApplied()
          }
        }).catch(function (err) {
          vm.error = String(err).replace('Error: ', '')
        })
    },
    register: function() {
      if (!this.sent) {
        return false
      }
      if (this.sent) {
        const vm = this
        this.validateForm()
        const params = {
          email: this.email,
          password: this.password,
          firstname: this.firstname,
          lastname: this.lastname,
          gender: this.gender,
          code: this.code
        }
        this.$axios.post('candidate/register', params).then(function(response) {
          const status = response.data.status
          // if (status === 'registered') {
          //   vm.validEmail = false
          //   vm.error = vm.cpLang('login.email_registered')
          //   return false
          // }
          if (status === 'password_invalid') {
            vm.error = vm.cpLang('login.password_limit')
            return false
          }
          if (status === 'email_invalid') {
            vm.error = vm.cpLang('apply.email_invalid')
            return false
          }
          if (status === 'verify_fail') {
            vm.error = vm.cpLang('login.code_invalid')
            vm.formError = vm.cpLang('login.code_invalid')
            return false
          }
          if (status === 'verify_expired') {
            vm.error = vm.cpLang('login.code_expired')
            return false
          }
          if (status === 'success') {
            vm.logging = true
            vm.$auth.loginWith('local', {
              data: {
                email: vm.email,
                password: vm.password
              }
            }).then(() => {
              location.reload()
            }).catch((err) => {
              vm.error = err.message
            })
          }
        })
      }
    },
    submitForm: function () {
      const vm = this
      this.afterSubmit = true
      this.validateForm()
      if (!this.valid || this.submitting) {
        return false
      }
      if (this.isMember && !this.isLoggedIn && !this.requirePassword) {
        return false
      }
      this.submitting = true
      const formData = new FormData()
      formData.append('positionid', this.$route.params.id)
      formData.append('email', this.email)
      formData.append('firstname', this.firstname)
      formData.append('lastname', this.lastname)
      formData.append('code', this.code)
      formData.append('password', this.password)
      formData.append('workpermit', this.permit)
      formData.append('newsletterstatus', this.newsLetterStatus ? 'Y' : 'N')
      formData.append('jobalertstatus', this.jobAlertStatus ? 'Y' : 'N')
      formData.append('thirdpartystatus', this.thirdPartyStatus ? 'Y' : 'N')
      if (this.pendingFile) {
        formData.append('resumedata', this.pendingFile)
      }
      formData.append('resumeid', this.resumeid)
      formData.append('resumename', this.filename)
      formData.append('coverletter', '')
      formData.append('tag', 'jobdetail_normal')
      this.$axios
        .post('applications', formData, {
          headers: {
            'Content-Type': 'application/form-data'
          }
        })
        .then(function (response) {
          vm.submitting = false
          vm.isMember = true
          const result = response.data
          if (result.status === 'success') {
            vm.showApplied()
          }
          if (result.status === 'register') {
            vm.isMember = true
            vm.loginAfterRegister = true
            vm.doLogin()
          }
        })
        .catch(function (err) {
          vm.submitting = false
          vm.error = String(err).replace('Error: ', '')
        })
    },
    doLogin: function () {
      if (!this.password || !this.isMember || this.email === '') {
        return false
      }
      const vm = this
      this.logging = true
      this.$auth
        .loginWith('local', {
          data: {
            email: this.email,
            password: this.password
          }
        })
        .then(() => {
          if (this.loginAfterRegister) {
            this.$router.push({
              path: '/myjob/nonmemberapplyreg/' + this.$route.params.id,
              redirect: 'actualRoute'
            })
            // this.showAppliedAndRegistered()
            return
          }
          this.firstname = this.$auth.user.firstname
          this.lastname = this.$auth.user.lastname
          this.$router.push({
            path: '/myjob/apply/' + this.$route.params.id,
            redirect: 'actualRoute'
          })
          vm.checkApplyStatus()
          // location.reload()
        })
        .catch((err) => {
          console.log(err)
          vm.logging = false
          vm.inputError = 'password'
          vm.formError = '*' + this.cpLang('login.fail')
        })
    },
    forgotPassword: async function () {
      const vm = this
      vm.forgotPasswordSent = false
      if (this.email === '') {
        this.formError = '*' + this.cpLang('apply.email_empty')
        this.inputError = 'email'
        return
      }
      if (!commonHelper.isValidEmail(this.email)) {
        this.formError = '*' + this.cpLang('apply.email_invalid')
        this.inputError = 'email'
        return
      }
      const params = { email: this.email, hash: vm.$cpCookie.get('cpid') }
      await this.$axios
        .post('candidate/forgotpassword', params)
        .then(function (response) {
          vm.forgotPasswordSent = true
          // const data = JSON.parse(JSON.stringify(response.data[0]))
          // console.log(data)
        })
    },
    beforeUpload: function (e) {
      if (this.resumes.length >= 5) {
        this.showDeleteResume = true
        this.uploadEvent = e
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    fblogin: function () {
      commonHelper.facebookLogin()
    },
    googlelogin: function () {
      commonHelper.googleLogin()
    },
    linkedinlogin: function () {
      commonHelper.linkedinLogin()
    },
    clearEmail: function () {
      this.login = false
      this.email = ''
      document
        .querySelector('#apply-prompt')
        .querySelector('#email-txt')
        .focus()
    },
    validateForm: function (verification) {
      this.formError = false
      this.cvError = false
      this.inputError = false
      if (this.email === '') {
        this.formError = '*' + this.cpLang('apply.email_empty')
        this.valid = false
        this.inputError = 'email'
        return false
      }
      if (!commonHelper.isValidEmail(this.email)) {
        this.formError = '*' + this.cpLang('apply.email_invalid')
        this.inputError = 'email'
        this.valid = false
        return false
      }

      const filled =
        this.password !== '' &&
        this.firstname !== '' &&
        this.lastname !== '' &&
        (this.resumeid !== '' || this.filename !== '')
      if (!this.afterSubmit && !filled && !this.$auth.loggedIn) {
        return
      }

      if (this.password === '' && this.requirePassword) {
        this.formError = '*' + this.cpLang('global.mandatory')
        this.inputError = 'password'
        this.valid = false
        return false
      }
      if (
        (this.password.length < 8 || this.password.length > 15) &&
        this.requirePassword
      ) {
        this.formError = '*' + this.cpLang('login.password_limit')
        this.inputError = 'password'
        this.valid = false
        return false
      }
      if (this.password !== this.confirmPassword && this.requirePassword) {
        this.formError = '*' + this.cpLang('login.password_not_matched')
        this.inputError = 'confirmPassword'
        this.valid = false
        return false
      }

      // only valid email and password for member;
      if (this.isMember) {
        this.valid = true
        this.error = false
        return false
      }
      if (this.firstname === '') {
        this.formError = '*' + this.cpLang('global.mandatory')
        this.inputError = 'firstname'
        this.valid = false
        return false
      }
      if (this.lastname === '') {
        this.formError = '*' + this.cpLang('global.mandatory')
        this.inputError = 'lastname'
        this.valid = false
        return false
      }
      if (!this.sent && this.requirePassword) {
        return true
      }
      if (verification === true) {
        return true
      }
      if (this.enableVerCode && this.code === '') {
        this.formError = '*' + this.cpLang('global.mandatory')
        this.valid = false
        this.inputError = 'verify'
        return false
      }
      if (!this.resumeid && this.filename === '' && this.afterSubmit) {
        this.cvError = '*' + this.cpLang('apply.cv_invalid')
        this.valid = false
        this.inputError = 'resume'
      }
      if (!this.inputError && (this.resumeid || this.filename !== '')) {
        this.valid = true
        this.error = false
      }
    },
    validateEmail: async function () {
      if (!commonHelper.isValidEmail(this.email)) {
        return
      }
      // try {
      const apiRes = await this.$axios.get(
        'candidate/validate?email=' + encodeURIComponent(this.email)
      )
      this.isMember = false
      this.requirePassword = false
      if (apiRes.data.status === 'registered') {
        this.isMember = true
      }
      if (apiRes.data.status === 'success') {
        this.requirePassword = true
        this.$nextTick(() => {
          document.getElementById('new-password').focus()
        })

        // setTimeout(function() {
        //   document.querySelector('#password_box').focus()
        // }, 1000)
      }
      // } catch (err) {
      //   this.error = err.response.message
      // }
    },
    showApplied: function () {
      window.location.href =
        '/myjob/applicationsubmitted/' + this.$route.params.id
      // this.$router.push({
      //   path: '/myjob/applicationsubmitted/' + this.$route.params.id
      // })
    },
    showAppliedAndRegistered: function () {
      window.location.href =
        '/myjob/nonmemberapplyreg/' + this.$route.params.id
      // this.$router.push({
      //   path: '/myjob/nonmemberapplyreg/' + this.$route.params.id
      // })
    },
    selectGender: function() {}
  }
}
</script>

<style lang="scss">
.page-myjob-apply-id {
  background: #f0f0f0;
  .cpj-wrapper {
    overflow: auto;
    min-height: 90vh;
    // background: transparent url(/asset/image/bg/apply-bg.svg) 0% 0% repeat-x padding-box;
    background-position: bottom;
  }
  .social-login-btn {
    position: relative;
    padding: 27px 15px 0px 30px;
    h4 {
      font-size: 14px;
      position: absolute;
      top: 50%;
      left: 0px;
      color: #707070;
    }
    h5 {
      display: none;
    }
    a {
      height: 36px;
      line-height: 16px;
      font-size: 12px;
    }
  }
}
#apply-prompt {
  font-size: 14px;
  margin: 10px auto;
  overflow: hidden;
  border-radius: 20px;
  border-radius: 20px;
  opacity: 1;
  .apply-prompt-wrap{
    padding: 30px;
    background-color: #fff;
    box-shadow: 0px 3px 10px #0000001A;
    border-radius: 20px;
    margin: 50px auto;
    position: relative;
    &:before{
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 80px;
      background: url(/asset/image/photo/cv_top_bg.png) transparent no-repeat;
      background-size: contain;
      border-radius: 20px;
      background-position: 0px 0px;
    }
    &:after{
      content: '';
      position: absolute;
      bottom: 0px;
      right: 0;
      width: 100%;
      height: 80px;
      background: url(/asset/image/photo/cv_top_bottom.png) transparent no-repeat;
      background-size: cover;
      border-radius: 20px;
      background-position: 0px -7px;
    }
    &.no-bg{
      background-color: transparent;
      box-shadow: unset;
      margin-top: 0px;
      margin-bottom: 0px;
      &:before{
        content: unset;
      }
      &:after{
        content: unset;
      }
    }
    .col-social{
      a{
        width: 100%;
        span{
          padding-left: 23px;
        }
      }
    }
    &:not(.editing-form) {
      max-width: 670px;
      .login-authbox {
        .col-social {
          a {
            text-align: center;
            width: 100%;
          }
        }
      }
      .tooltip {
        background: #333333;
        padding: 5px 15px;
        border-radius: 3px;
        box-shadow: 5px 5px 10px #00000066;
        color: #fff;
        font-size: 12px;
        display: none !important;
        .fa-sort-up {
          color: #333333 !important;
          left: 20px;
          top: -6px !important;
          right: auto !important;
          font-size: 20px;
        }
        &.show {
          display: block !important;
        }
      }
      .to-reg {
        position: relative;
        z-index: 10;
        margin-top: 10px;
        margin-bottom: 30px;
        b {
          cursor: pointer;
        }
      }
      input:read-only {
        cursor: not-allowed;
      }
      .btn-primary {
        min-width: 150px;
      }
      .position-relative {
        .fas {
          position: absolute;
          right: 25px;
          top: 12px;
          color: #999;
        }
      }
      .btn-send {
        border-radius: 4px;
        position: absolute;
        right: 22px;
        min-width: auto;
        max-width: 80px;
        top: 9px;
        text-transform: uppercase;
      }
      .verify-msg {
        color: #707070;
        font-size: 12px;
        margin-bottom: 10px;
      }
      .subscriptions {
        margin-top: 10px;
      }
      .subscriptions label {
        line-height: 1.25;
      }
      .fa-keyboard {
        position: absolute;
        left: 25px;
        top: 10px;
        color: #cccccc;
        font-size: 18px;
      }
      #reg_code {
        padding-left: 35px;
      }
      small {
        font-size: 12px;
        color: #707070;
        line-height: 1.25;
        display: inline-block;
        margin-bottom: 10px;
        a {
          display: inline-block;
          margin: 5px 0px;
        }
      }
      .text-success small {
        color: #28a745 !important;
      }
      h2 {
        padding: 20px 0;
        font-size: 18px;
        color: #707070;
        text-align: center;
        font-weight: bold;
        position: relative;
      }
      h3 {
        font-size: 16px !important;
        text-align: center;
        font: Bold 18px/20px Open Sans;
        letter-spacing: 0;
        color: #0081BE;
      }
      h4 {
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
        color: #707070;
      }
      h5 {
        font-size: 16px;
        letter-spacing: 0;
        color: #707070;
        font-weight: bold;
        text-align: center;
        label {
          float: right;
          font-size: 10px;
          font-weight: normal;
          line-height: 25px;
          vertical-align: bottom;
          margin-bottom: 0px;
        }
      }
      h6 {
        font-size: 14px;
        text-align: center;
        font: Regular 14px/19px Open Sans;
        letter-spacing: 0;
        color: #707070;
      }
      form {
        padding: 10px;
      }
      .has-danger {
        .form-control {
          border-color: #0EA5BF;
        }
      }
      .form-control {
        height: 40px;
        border-color: #f4f4f4;
        background-color: #f4f4f4;
        font-size: 14px;
        margin-bottom: 10px;
        color: #000;
        border-radius: 50px;
      }
      .form-check-label {
        color: #707070;
        font-size: 12px;
        margin-bottom: 5px;
        text-align: left;
      }
      .cv-upload {
        padding: 7px 0px 7px 10px;
        h4 {
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          color: #707070;
          line-height: 34px;
          margin: 0px;
        }
        .btns {
          vertical-align: top;
          padding: 0px 0px 0px 4px;
          max-height: 52px;
        }
        small {
          transform: scale(0.85);
          padding: 4px 0px 0px 0px;
          margin: 0px -30px;
          width: 110%;
        }
      }
    }
  }
  &.editing-form {
    max-width: 910px;
    padding: 30px;
    .editing-heading {
      font-size: 16px;
      text-align: center;
    }
    .profile-picture {
      position: relative;
    }
    .part {
      background: #fff;
      border-radius: 20px;
      padding: 30px;
      margin-bottom: 20px;
      box-shadow: 0px 3px 10px #0000001a;
    }
  }
}
.login-prompt {
  width: 100%;
  height: 100%;
  a {
    color: #788796 !important;
  }
}
.cv-prompt {
  tr:hover {
    background-color: #ececec;
  }
  td {
    padding: 4px;
    font-size: 13px;
    i {
      cursor: pointer;
    }
  }
}
.cv-option {
  ul {
    margin: 0px -3px;
    list-style: none;
    padding: 0px;
  }
  li {
    display: block;
    width: 100%;
    position: relative;
    font-size: 12px;
    max-height: 20px;
    margin-bottom: 5px;
    label {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.alert-danger {
  font-size: 13px;
  padding: 10px;
  margin: 10px auto -20px auto;
}
.cv-preview {
  div {
    max-height: 150px;
    overflow: hidden;
    border: 1px solid #707070;
    min-height: 130px;
    background-color: #c7c7c7;
    img {
      width: 100%;
    }
  }
}
.loading-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  left: 0px;
  top: 0px;
  cursor: wait;
  background: rgba(255, 255, 255, 0.4);
  .fa-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 101;
    font-size: 30px;
    margin-left: -15px;
    margin-top: -15px;
  }
  &.editpreview{
    position:fixed;
  }
}
.cheat-password {
  width: 0px;
  height: 0px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
}
.isusermail {
  color: #c1c1c1 !important;
}
.reg-wrap{
  margin-top: 30px;
}
.preview-profile-section{
  // margin-top: 28px;
  .myprofile{
    margin-top: 0 !important;
  }
}
.up-index{
  z-index: 10;
  .cs-tooltip{
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
